import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Karta kredytowa',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Przelew bankowy',
    [PaymentMethod.SepaDebit]: 'Karta EC / IBAN',
    [PaymentMethod.Cash]: 'Gotówka',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Inna metoda płatności',
  },
};
